import { ArrowLeftFullIcon } from '@libs/ui/ds/assets/icons/ArrowLeftFullIcon'
import { SwitchAt, IconButton } from '@libs/ui/ds/lib/components'
import { createButton } from '@libs/ui/ds/lib/components/buttons/BaseButton/utils/createButton'
import { Button } from '@libs/ui/ds/lib/components/buttons/Button/base/Button'

import type { BackButtonProps } from './BackButton.types'

export const BackButton = createButton<BackButtonProps>(
  ({ children, switchAt = null, ...other }) => {
    return (
      <SwitchAt
        breakpoint={switchAt}
        larger={
          <Button
            variant='tertiary'
            intent='neutral-dark'
            size='m'
            leftIcon={<ArrowLeftFullIcon />}
            {...other}
          >
            {children}
          </Button>
        }
        smaller={
          <IconButton
            variant='tertiary'
            intent='neutral-dark'
            size='m'
            icon={<ArrowLeftFullIcon />}
            {...other}
          />
        }
      />
    )
  }
)

export type { BackButtonProps } from './BackButton.types'
